import React from 'react';
import { IFilterProps } from 'types/frontend_models/table/IFilterProps';
import { Select } from 'antd';
import { SelectValue } from 'antd/lib/select';
import { ICustomSelectOptionModel } from 'functions/DataConverters';

interface IProps extends IFilterProps
{
	options: ICustomSelectOptionModel[],
	defaultOption?: ICustomSelectOptionModel
}

/** Input element used to filter table data */
function TableSelectFilter(props: IProps)
{
	let defaultValue: string | number | undefined = undefined;
	if (props.defaultOption) {
		defaultValue = props.defaultOption.value;
	} else if (props.options.length !== 0) {
		defaultValue = props.options[0].value;
	}

	function onChange(value: SelectValue)
	{
		props.setFilter(props.column.id as string, value);
	}

	return (
		<Select onChange={onChange} bordered={false} defaultValue={defaultValue} style={{ width: '100%' }}>
			{props.options.map((option, index) =>
			{
				return (
					<Select.Option
						key={option.value}
						value={option.value}>
						{option.label}
					</Select.Option>
				);
			})}

		</Select>
	);
};

export default TableSelectFilter;